import { CommonModule } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatCheckboxModule } from "@angular/material/checkbox";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { firstValueFrom, of } from "rxjs";
import { ButtonComponent } from "src/app/common/components/core/button/button.component";
import { InputComponent } from "src/app/common/components/core/input/input.component";
import { ConfirmationModalComponent } from "src/app/common/components/core/modal/confirmation-modal/confirmation-modal.component";
import * as config from "./esignature-attestation.config";
import { CompleteSettingsComponent } from "../../set-up/complete-settings/complete-settings.component";
import { UserEsignatureClient } from "src/app/common/services/user-esignature.client";
import { AuthService } from "src/app/services/auth.service";
import { StorageService } from "src/app/common/services/storage.service";
import { environment } from "environment";

@Component({
  selector: "app-esignature-attestation",
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonComponent,
    InputComponent,
    MatCheckboxModule,
  ],
  templateUrl: "./esignature-attestation.component.html",
})
export class EsignatureAttestationComponent implements OnInit {
  readonly continueButtonConfig = config.continueButtonConfig;
  readonly okButtonConfig = config.okButtonConfig;
  displaySuccess: boolean = false;
  formGroup!: FormGroup;
  isPhysician: boolean = false;
  token: string = "";
  refreshToken: string = "";
  user: string = "";

  constructor(
    private matDialogRef: MatDialogRef<EsignatureAttestationComponent>,
    private matDialog: MatDialog,
    private formBuilder: FormBuilder,
    private esignatureClient: UserEsignatureClient,
    private authService: AuthService,
    private storageService: StorageService,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.isPhysician = this.data.isPhysician;
  }

  ngOnInit(): void {
    const { token, refreshToken, user } = this.storageService.getAndRemoveLoginData();
    this.token = token;
    this.refreshToken = refreshToken;
    this.user = user;
    this.formGroup = this.formBuilder.group({
      acknowledgement: [false, Validators.requiredTrue],
      signature: [""],
      confirmSignature: [""],
    });
    this.formGroup.addValidators([
      config.signatureValidator,
      config.bothSignaturesPresent,
    ]);
    this.formGroup.errors;
  }

  async continue(): Promise<void> {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.invalid) {
      return;
    }

    try {
      if (this.isPhysician) {
        this.storageService.resetLoginData(this.token, this.refreshToken, this.user);
        await firstValueFrom(
          this.matDialog
            .open(CompleteSettingsComponent, {
              disableClose: true,
              autoFocus: false,
              data: {
                buttonText: "Save",
                hideCancelButton: true,
                esignature: this.formGroup.value.signature,
                confirmEsignature: this.formGroup.value.confirmSignature,
              },
            })
            .afterClosed()
        );
      } else {
        try {
          this.storageService.resetLoginData(this.token, this.refreshToken, this.user);
          await firstValueFrom(
            this.esignatureClient.createOrUpdateESignature(
              this.formGroup.value.signature,
              this.formGroup.value.confirmSignature
            )
          );
        } catch (error: any) {
          this.matDialog.open(ConfirmationModalComponent, {
            data: {
              title: "Error",
              message: (error as any)?.error,
              buttonText: "OK",
              hideCancelButton: true,
              isError: true,
            },
          });
          this.authService.reAuthenticate();
          return;
        }
      }

      this.displaySuccess = true;
      // this.matDialogRef.close(true);
    } catch (error) {
      this.matDialog.open(ConfirmationModalComponent, {
        data: {
          title: "Error",
          message: (error as any)?.error,
          buttonText: "OK",
          hideCancelButton: true,
          isError: true,
        },
      });
      this.authService.reAuthenticate();
      return;
    }
  }

  close(): void {
    // commentted the code to avoid the double navigations
    // if(this.isPhysician) {
    //   window.location.href = `${environment.zpaxEsignatureDocumentRedirectEndPoint}`
    // };
    this.matDialogRef.close(false);
  }
}
